<template>
  <Timeline :style="{backgroundColor: '#fff'}">
    <TimelineItem :style="{padding: '15px'}" :color="item.color" v-for="item in logs_own" :key="item.id">
      <p class="time">{{ item.datetime_format }}</p>
      <p class="content"><b>修改内容：</b>{{ item.content }}</p>
      <p><b>操作人：</b>{{ item.user.username }}</p>
    </TimelineItem>
  </Timeline>
</template>
<script>
export default {
  name: 'Logs',
  props: ['logs'],
  data () {
    return {
      logs_own: this.logs
    }
  },
  watch: {
    logs () {
      let logsTmp = []
      this.logs.map((item, index) => {
        if (item.type === 'error') {
          item['color'] = 'red'
        } else {
          item['color'] = 'green'
        }
        logsTmp.push(item)
      })
      this.logs_own = logsTmp
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>
<style>
  .time{
    font-size: 14px;
    font-weight: bold;
  }
  .ivu-timeline-item-tail {
    border-left: 0 !important;
  }
  .content {
    word-wrap: break-word;
  }
</style>
